<template lang="html">
  <footer>

	<div class="container">

		<div class="row">
			<div class="col-md-60 logo">
        <router-link :to="{ name: 'Home' }" class="brand">
          <lazy-image :src="$utils.config.static + 'img/logo_doity.png'" title="Doity" />
        </router-link>
				<p class="brand-text">{{ $t('rodape.brand') }}</p>
			</div>
			<div v-if="$route.name != 'Aplicativo'" class="col-md-40 acao">
        <router-link :to="{ name: 'Criar evento' }" class="btn-verde transform-uppercase pull-right">{{ $t('botao.criar-evento') }}</router-link>
			</div>
		</div><!-- /row -->

		<div class="row row-last">
			<div class="col-md-40">
				<div class="row">
					<div class="col-md-100">
						<h6 class="transform-uppercase has-line">{{ $t('rodape.sobre-a-doity') }}</h6>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-33">
						<ul class="footer-links">
							<li><router-link :to="{ name: 'Quem somos' }">{{ $t('rodape.links.quem-somos') }}</router-link></li>
							<li><router-link :to="{ name: 'Home', query: { scroll: 'site_do_evento' } }">{{ $t('rodape.links.servicos') }}</router-link></li>
							<li><router-link :to="{ name: 'Quanto custa' }">{{ $t('rodape.links.quanto-custa') }}</router-link></li>
							<li><router-link :to="{ name: 'Eventos' }">{{ $t('rodape.links.eventos') }}</router-link></li>
						</ul>
					</div>
					<div class="col-xs-33">
						<ul class="footer-links">
              <li><router-link style="max-width:97%;" :to="{ name: 'Área do participante' }">{{ $t('rodape.links.area-de-inscritos') }}</router-link></li>
              <li><router-link :to="{ name: 'Política de Privacidade' }">{{ $t('rodape.links.politica-de-privacidade') }}</router-link></li>
              <li><router-link :to="{ name: 'Contato' }">{{ $t('rodape.links.contato') }}</router-link></li>
						</ul>
					</div>
					<div class="col-xs-33">
						<ul class="footer-links">
              <li><a href="//blog.doity.com.br/" target="_blank">{{ $t('rodape.links.blog') }}</a></li>
              <li><a href="http://ajuda.doity.com.br" target="_blank">{{ $t('rodape.links.central-de-ajuda') }}</a></li>
              <li><router-link :to="{ name: 'Login' }">{{ $t('rodape.links.login') }}</router-link></li>
						</ul>
					</div>
				</div>
			</div><!-- /col -->

			<div class="col-xs-100 col-md-offset-2 col-md-25 atendimento">
        <h6 class="transform-uppercase has-line">{{ $t('rodape.contatos.titulo') }}</h6>
				<p>(82) 3034-0909</p>
				<p>(11) 3230-9252</p>
				<p>{{ $t('rodape.contatos.horario') }}</p>
				<p class="email transform-uppercase">contato@doity.com.br</p>
				<ul class="social">
          <li><a href="//www.facebook.com/DoityBrasil" target="_blank"><i class="fa fa-facebook"></i></a></li>
          <li><a href="//www.instagram.com/doitybrasil" target="_blank"><i class="fa fa-instagram"></i></a></li>
          <li><a href="//www.linkedin.com/company/doity" target="_blank"><i class="fa fa-linkedin"></i></a></li>
					<li><a href="//www.twitter.com/doitybrasil" target="_blank"><i class="fa fa-twitter"></i></a></li>
					<li><a href="//www.youtube.com/channel/UC8RThVprzGquY9wp5EbWH2A" target="_blank"><i class="fa fa-youtube"></i></a></li>
				</ul>
			</div>
			<div class="col-xs-100 col-md-offset-2 col-md-30 endereco">
				<address class="transform-uppercase">
					Rua José Pontes de Magalhães, 70<br/>
					JTR, Edif Itália, Sala 702<br/>
					Jatíuca, Maceió - Alagoas
				</address>
				<a target="_blank" href="https://www.google.com.br/maps/place/Doity+%7C+Plataforma+de+Eventos/@-9.6525856,-35.7032985,17z/data=!3m1!4b1!4m5!3m4!1s0x70145b08e7e02e1:0xa2e49c885d713f07!8m2!3d-9.6525856!4d-35.7011098?dcr=0" class="transform-uppercase btn btn-vermelho veja-mapa">{{ $t('botao.veja-no-mapa') }}</a>
			</div>
		</div><!-- /row -->

		<div class="row parceiros">
			<a v-for="item in parceiros" :href="item.link" target="_blank" :key="item.id">
        <lazy-image :src="item.imagem" :title="item.nome" />
      </a>
		</div>

	</div><!-- /container -->

</footer>
</template>

<script>
export default {
  data () {
    return {
      parceiros: [
        {
          link: 'http://www.sebrae.com.br/',
          nome: 'Sebrae',
          imagem: `${this.$utils.config.static}img/footer/sebrae.png`
        },
        {
          link: 'http://www.abeoc.org.br/',
          nome: 'ABEOC',
          imagem: `${this.$utils.config.static}img/footer/abeoc.png`
        },
        {
          link: 'https://www.facebook.com/sururuvalleyoficial',
          nome: 'Sururu Valley',
          imagem: `${this.$utils.config.static}img/footer/sururuvalley.png`
        },
        {
          link: 'https://www.bossainvest.com/',
          nome: 'Bossa Nova',
          imagem: `${this.$utils.config.static}img/footer/bossanova.png`
        },
        {
          link: 'http://www.amigodosurdo.com/',
          nome: 'Amigo do Surdo',
          imagem: `${this.$utils.config.static}img/footer/amigodosurdo-selo-100x100.png`
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">

.has-line {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0; right: 0;
    height: 4px;
    background-color: $color-vermelho;
  }
}

footer {
  z-index: 2;
  font-size: 13px;
  padding: 75px 0 0 0;
  color: $color-preto;
  background-color: $color-branco;

  h6 {
    font-size: 16px;
    font-family: $proxima-nova-bold;
    font-weight: normal;
    margin: 20px 0px;
    text-transform: uppercase;
  }

  .veja-mapa {
    margin-top: 20px;
    padding-left: 25px;
    padding-right: 25px;
  }
}

footer .logo {
  display: flex;
  align-items: center;
}
footer .brand {
  display: inline-block;
  margin-right: 10px;
}
footer .brand:after {
  content: none;
}
footer .brand .corpo-logo {
  fill: #333;
}
footer .brand .destaque-logo {
  fill: $color-vermelho;
}
footer .brand-text {
  margin-left: 20px;
  display: inline-block;
  font-size: 18px;
  font-family: $proxima-nova-semi-bold;
  color: $color-vermelho;
}
footer .row-last {
  margin-top: 75px;
}

footer .footer-links {
  list-style: none;
  padding-left: 0px;
}
.footer-links li {
  margin-bottom: 5px;
}
.footer-links a {
  font-family: $proxima-nova-semi-bold;
  display: inline-block;
  font-size: 14px;
  color: $color-preto;
	transition: .2s ease-in-out all .1s;

	&:hover {
		color: $color-vermelho;
	}
}
footer .atendimento,
footer .endereco {
  margin-top: 0px;
}
footer .atendimento p {
  font-family: $proxima-nova-bold;
  text-decoration: none;
  color: currentColor;
}
footer .atendimento p,
footer .atendimento ul {
  font-size: 13px;
  margin: 5px 0;
}
footer .atendimento .email {
  margin-bottom: 10px;
  margin-top: 20px;
}
footer .social {
  list-style: none;
  padding: 0px;
}
footer .social li:hover {
  background-color: $color-vermelho;
}
footer .social li {
  transition: .2s ease-in-out all;
  text-align: center;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  height: 30px;
  width: 30px;
  line-height: 2;
  border: 2px solid $color-vermelho;
}
footer .social a:hover {
  color: #fff;
}
footer .social a {
  color: $color-vermelho;
  display: block;
}
footer .endereco {
  margin-top: 55px;
  font-size: 13px;
}
footer .endereco address {
  font-style: normal;
  line-height: 1.3;
  font-family: $proxima-nova-bold;
}

footer .row.parceiros {
  border-top: 1px solid $color-cinza-footer;
  padding-top: 15px;
  margin-top: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
}

footer .row.parceiros a {
  margin: 0 25px;
}

footer .row.parceiros a img {
  width: 100%;
	height: 100%;
}

@media (max-width: 1023px) {
  footer .logo {
    flex-flow: column;
  }

  footer .brand-text {
    margin: 5px 0 10px 0;
  }

  footer .acao {
    display: flex;
    justify-content: center;
  }

  footer .row.parceiros {
    flex-wrap: wrap;
  }

	footer .atendimento,
	footer .endereco {
		text-align: center;
	}

	footer .social li {
		font-size: 18px;
	  line-height: 41px;
	  width: 43px;
	  height: 43px;
	}

  footer .row.parceiros a {
    flex-shrink: 0;
  }

  .btn-verde {
    text-align: center;
  }
}

@media (min-width: 1280px) {
	footer .atendimento,
	footer .endereco {
		padding-left: 20px;
	}

	footer .endereco address {
	  margin-bottom: 35px;
	}

	footer .social li {
	  line-height: 32px;
	  width: 35px;
	  height: 35px;
	}
}


</style>



// WEBPACK FOOTER //
// src/components/FooterDoity.vue